/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `Vaše heslo bylo aktualizováno.`
};

const da_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `Din adgangskode er blevet opdateret.`
};

const de_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `Ihr Passwort wurde aktualisiert.`
};

const en_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `Your password has been updated.`
};

const es_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `Tu contraseña ha sido actualizada.`
};

const fr_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `Votre mot de passe a été mis à jour.`
};

const hu_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `A jelszavad frissítésre került.`
};

const it_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `La tua password è stata aggiornata.`
};

const nl_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `Je wachtwoord is bijgewerkt.`
};

const pl_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `Twoje hasło zostało zaktualizowane.`
};

const pt_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `Sua senha foi atualizada.`
};

const sv_account_password_renewed = /** @type {(inputs: {}) => string} */ () => {
	return `Ditt lösenord har uppdaterats.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_password_renewed = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_password_renewed(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_password_renewed", locale)
	if (locale === "cs") return cs_account_password_renewed(inputs)
	if (locale === "da") return da_account_password_renewed(inputs)
	if (locale === "de") return de_account_password_renewed(inputs)
	if (locale === "en") return en_account_password_renewed(inputs)
	if (locale === "es") return es_account_password_renewed(inputs)
	if (locale === "fr") return fr_account_password_renewed(inputs)
	if (locale === "hu") return hu_account_password_renewed(inputs)
	if (locale === "it") return it_account_password_renewed(inputs)
	if (locale === "nl") return nl_account_password_renewed(inputs)
	if (locale === "pl") return pl_account_password_renewed(inputs)
	if (locale === "pt") return pt_account_password_renewed(inputs)
	return sv_account_password_renewed(inputs)
};
export { account_password_renewed as "account.password_renewed" }